import { ErrorTriageState } from '@common/interfaces/errorTriage'
import Base from './base'

export default class ErrorTriage extends Base {
  list(params = {}) {
    return this.apiClient.get('/error-triage', params)
  }

  /** Every error's occurrences — the Live tab. */
  listOccurrences(params = {}) {
    return this.apiClient.get('/error-triage/occurrences', params)
  }

  /** One error's occurrences — the drawer. */
  listTriageOccurrences(id: string, params = {}) {
    return this.apiClient.get(`/error-triage/${id}/occurrences`, params)
  }

  show(id: string) {
    return this.apiClient.get(`/error-triage/${id}`)
  }

  updateState(id: string, state: ErrorTriageState) {
    return this.apiClient.put(`/error-triage/${id}/state`, { state })
  }

  autoFix(id: string) {
    return this.apiClient.post(`/error-triage/${id}/auto-fix`)
  }

  investigate(id: string) {
    return this.apiClient.post(`/error-triage/${id}/investigate`)
  }
}
